import React from 'react'
import AccountModal from "./Accountmodal";
import { useEffect, useState } from "react";
import { getAllowance, getBalance, getTokenContract } from "../../helpers/getterFunctions";
import { approveUSDT, buyRobUsingUSDT, approveBUSD, buyRobUsingBUSD, getPriceWithCode, getUserPromoCode } from "../../helpers/setterFunctions";
import { connect } from "react-redux";
import "./../../App.css";
import { getWeb3 } from "../../helpers/currentWalletHelper"

import logo from './../../assets/images/logo.png';
import coin from './../../assets/images/coin.png';
import logoMobile from './../../assets/images/logo-mobile.png';

import twitter from './../../assets/images/social/twitter.png';
import facebook from './../../assets/images/social/facebook.png';
import instagram from './../../assets/images/social/instagram.png';
import telegram from './../../assets/images/social/telegram.png';
import medium from './../../assets/images/social/medium.png';
import GeneralModal from "./wrongNetworkModal";


function Header(props) {
  const [days, setDays] = useState(0)
  const [hours, setHours] = useState(0)
  const [minutes, setMinutes] = useState(0)
  const [tokenPrice, setTokenPrice] = useState(0.20)
  const [discountedTokenPrice, setdiscountedTokenPrice] = useState("")
  const [totalAmount, setTotalAmount] = useState("")
  const [discountedAmount, setDiscountedAmount] = useState("")
  const [totalToken, setTotalToken] = useState("")
  const [currency, setCurrency] = useState("USDT")
  const [loading, setLoading] = useState(false)
  const [userCoupon, setUserCoupon] = useState("")
  const [coupon, setCoupon] = useState("")
  const [couponModal, setCouponModal] = useState(false)
  const [inputCode, setInputCode] = useState("")
  const [title, setTitle] = useState("")
  const [message, setMessage] = useState("")
  const [show, setShow] = useState(false)
  const [link, setLink] = useState(false)
  const [year] = useState(new Date().getFullYear())

  const onClickApplyCode = async() => {
  if (props && props.web3) {
    await validatePromoCode(props.web3.web3);
  } else {
    setTitle("Wallet Not Connected.");
    setMessage("Please Connect Your wallet.");
    setShow(true);
  }
  };

  useEffect(() => {
    const countDownDate = 1647302399000;
    let x = setInterval(function () {

      // Get today's date and time
      // let now = new Date().getTime();
      let now = new Date();
      now = now.toUTCString();
      now = new Date(now).getTime();
      // Find the distance between now and the count down date
      let distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      setDays(Math.floor(distance / (1000 * 60 * 60 * 24)));
      setHours(Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
      setMinutes(Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)));
      
      // If the count down is finished, write some text
      if (distance < 0) {
        clearInterval(x);
        setDays(0);
        setHours(0);
        setMinutes(0);
      }
    }, 1000);
  }, [])
  useEffect(() => {
    async function fetchData() {
      // let web3 = await getWeb3();
      if (props && props.web3) {
          const chainId = await props.web3.web3.eth.getChainId();
          if (chainId.toString() === process.env.REACT_APP_CHAIN_ID) {
            await getInitialPrice(props.web3.web3);
            await userPromoCode(props.web3.web3);
          } else {
            //alert("wrong network");
            setTitle("Wrong Network");
            const msg = "Please choose " + process.env.REACT_APP_NETWORK + " Network";
            setMessage(msg);
            setShow(true);
          }
        }
      }
    fetchData();
  }, [props.account]);



  const getInitialPrice = async (web3) => {
    try {
      const price = await getPriceWithCode("", web3);
      if (price) {
        setTokenPrice(price);
      }
    }
    catch (err) {
      console.log(err);
    }
  }

const copy = async (textToCopy) => {
    await copyText(textToCopy);
    setTitle("Text Copied!!");
    setMessage("Text Copied successfully.");
    setShow(true);
}

  // return a promise
const copyText = async (textToCopy) => {
    // navigator clipboard api needs a secure context (https)
    if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard api method'
        return navigator.clipboard.writeText(textToCopy);
    } else {
        // text area method
        let textArea = document.createElement("textarea");
        textArea.value = textToCopy;
        // make the textarea out of viewport
        textArea.style.position = "fixed";
        textArea.style.left = "-999999px";
        textArea.style.top = "-999999px";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        return new Promise((res, rej) => {
            // here the magic happens
            document.execCommand('copy') ? res() : rej();
            textArea.remove();
        });
    }
}

  const validatePromoCode = async (web3) => {
    if (props.account && props.account.account) {
      setCoupon(inputCode);
      const price = await getPriceWithCode(inputCode, web3);
      if (price) {
        setTotalAmount((tokenPrice * totalToken).toFixed(6));
        setDiscountedAmount((totalToken * price).toFixed(6));
        if (tokenPrice != price) {
          setdiscountedTokenPrice(price);
        } else {
          setdiscountedTokenPrice(0);
        }
      }
    }
  }

  const userPromoCode = async (web3) => {
    if (props.account && props.account.account) {
      const promos = await getUserPromoCode(props.account.account, web3);
      if (promos) {
        setUserCoupon(promos);
      }
      console.log(userCoupon);
    }
  }

  const cancelModel = async () => {
    setCouponModal(false);
  }

  const getCode = async (code) => {
    setInputCode(code.target.value);
  }

  const resetValues = async (web3) => {
    await getInitialPrice(web3);
    setdiscountedTokenPrice(null)
    setTotalAmount('')
    setDiscountedAmount("")
    setTotalToken("")
    setCurrency("USDT")
    setUserCoupon("")
    setCoupon("")
    document.getElementById('code').value = ''
    await userPromoCode(web3);
  };

  const calculatePrice = (totalAmount) => {
    setTotalToken(totalAmount.target.value);
    setTotalAmount((totalAmount.target.value * tokenPrice).toFixed(6));
    const newDiscountedTokenPrice = !!discountedTokenPrice ? discountedTokenPrice : tokenPrice;
    setDiscountedAmount((newDiscountedTokenPrice * totalAmount.target.value).toFixed(6));
  }

  const set_Currency = (currency) => {
    setCurrency(currency.target.value);
  }

  const zeroPad = (num, places) => {
    var zero = places - num.toString().length + 1;
    return Array(+(zero > 0 && zero)).join("0") + num;
  }

  const buyTokens = async () => {
    if (props.account && props.account.account && currency == "USDT" && props.web3) {
      setLoading(true);
      const res1 = await approveUSDT(
        props.account.account,
        discountedAmount,
        props.web3.web3,
      );
      setLoading(false);
      if (res1 && res1.status === true) {
        setLoading(true);
        const res2 = await buyRobUsingUSDT(
          props.account.account,
          discountedAmount,
          coupon,
          props.web3.web3,
        );
        setLoading(false);
        if (res2 && res2.status === true) {
          await resetValues(props.web3.web3);
          if (!userCoupon) {
           setCouponModal(true);
          }
          setTitle("Token purchased");
          setMessage("Token purchased successfully.");
          const txnLink = process.env.REACT_APP_TRANSACTION_LINK + res2.transactionHash;
          setLink(txnLink);
          setShow(true);
        }
      }
    } else if (props.account && props.account.account && currency == "BUSD" && props.web3) {
      setLoading(true);
      const res3 = await approveBUSD(
        props.account.account,
        discountedAmount,
        props.web3.web3,
      );
      setLoading(false);
      if (res3 && res3.status === true) {
        setLoading(true);
        const res4 = await buyRobUsingBUSD(
          props.account.account,
          discountedAmount,
          coupon,
          props.web3.web3,
        );
        setLoading(false);
        if (res4 && res4.status === true) {
          await resetValues(props.web3.web3); 
          if (!userCoupon) {
           setCouponModal(true);
          }
          setTitle("Token purchased");
          setMessage("Token purchased successfully.");
          const txnLink = process.env.REACT_APP_TRANSACTION_LINK + res4.transactionHash;
          setLink(txnLink);
          setShow(true);
        }
      }
    } else {
      setTitle("Wallet Not Connected.");
      setMessage("Please Connect Your wallet.");
      setShow(true);
    }
  }

  useEffect(() => {
    // console.log("here")
    getTokenContract("usdt")
    // if (props.account && props.account.account) {
    //   console.log("props",props.account)
    //   getAllowance("usdt", props.account.account)
    //   // getBalance("usdt", props.account.account)
    // }
  }, [props.account])
  return (
    <>
      <div className="main-page">
        <header className="header">
          <div className="container-wrapper ">
            <div className="row align-items-center">
              <div className="col-md-4 col-4">
                <img alt="" src={logo} width={'250px'} className="d-none-sm" />
                <img alt="" src={logoMobile} width={'45px'} className="d-none-desk" />
              </div>
              <div className="col-md-8 col-8">
                <div className="text-right">
                  <AccountModal />
                </div>
              </div>
            </div>
          </div>
        </header>

        <div className="container-wrapper ">
          <div className="top-head">
            <div className="row">
              <div className="col-md-7">
                <p className="text-white text-uppercase font-18 font-14-sm">THE PRE-IEO SALE IS LIVE</p>
                <h1 className="font-weight-bold font-84 text-white font-32-sm">Reach your next <br />peak of happiness</h1>
                <div className="row">
                  <div className="col-md-8">
                    <p className="text-white mt-5 font-18 font-14-sm">
                      SuperOne is a pure-play in the booming crypto gaming industry and creates the world’s leading play-to-earn trivia game. SuperOne is about to engage billions of sports and entertainment fans by unlocking fame, fortune, and friendship opportunities.
                    </p>
                  </div>
                </div>
                <div className="mt-5 hero-btn-mobile">
                  <a href="https://so.link/lightpaper" target="_blank" className="btn btn-theme">Light Paper</a>
                  <a href="https://so.link/whitepaper" target="_blank" className="btn btn-theme-outline ml-4">White Paper</a>
                </div>
              </div>
            </div>
          </div>
        </div>


        <div className="container-wrapper mt-5 n-container-sm">
          <div className="row">
            <div className="col-12">
              <div className="parent-ieo">
                <div className="pre-ieo">
                  <div className="row">
                    <div className="col-md-7">
                      <div className="d-flex align-items-center justify-center-sm">
                        <img alt="" src={coin} width={'250px'} className="d-none-sm" />
                        <div className="ml-1">
                          <div className="text-yellow font-20 font-16-sm">Pre-IEO Token Sale Ends</div>
                          <div className="text-white font-25 noto-light mt-3 font-18-sm">Monday, March 14, 24:00 UTC</div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-5">
                      <div className="count-down">
                        <div>
                          <div className="up_t">{zeroPad(days, 2)}</div>
                          <span className="text_t">Days</span>
                        </div>
                        <div className="dots">:</div>
                        <div>
                          <div className="up_t">{zeroPad(hours, 2)}</div>
                          <span className="text_t">HRS</span>
                        </div>
                        <div className="dots">:</div>
                        <div>
                          <div className="up_t">{zeroPad(minutes, 2)}</div>
                          <span className="text_t">MIN</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mobile-logo-icon">
                  <img alt="" src={coin} width={'250px'} className="" />
                </div>
                <div className="ieo-dropdown">
                  <div className="row">
                    <div className="col-md-3">
                      <label htmlFor="">Token Amount</label><br />
                      <input onChange={(el) => calculatePrice(el)} type="number" className="w-100" className="form-control" value={totalToken} placeholder="0" />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="">Purchasing Currency</label><br />
                      <select value={currency} name="" className="form-control" id="" onChange={(el) => set_Currency(el)}>
                        <option value="USDT">USDT</option>
                        <option value="BUSD">BUSD</option>
                        {/* <option value="curreny">Other 2</option>
                        <option value="curreny">Other 3</option> */}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="">Total Amount</label><br />
                      <input onChange={(el) => { }} type="number" className="w-100" className="form-control" value={parseFloat(totalAmount)} placeholder="0" />
                    </div>
                    <div className="col-md-3">
                      <label htmlFor="">Discounted Amount</label><br />
                      <input onChange={(el) => { }} type="number" className="w-100" className="form-control" value={parseFloat(discountedAmount)} placeholder="0" />
                    </div>
                  </div>
                </div>



                <div className="ieo-coupon">
                  <div className="row">
                    <div className="col-md-6">
                      <p className="text-white">Token Price</p>
                    </div>
                    <div className="col-md-6" style={{ display: "flex" }}>
                      {/*<button onClick={() => userPromoCode()} className="btn btn-buy btn-outline-secondary" disabled={!!userCoupon}>Get Coupon</button>*/}
                      {/*<p className="text-white" style={{ margin: "0px", padding: "7px 10px" }}>{userCoupon}</p>*/}
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-md-6">
                      <div className="font-65 text-white font-c-mm">
                        {!discountedTokenPrice ? <span className="mr-3">${tokenPrice > 0 ? parseFloat(tokenPrice.toFixed(6)) : ""}</span> : ""}
                        {!!discountedTokenPrice ? <><span className="mr-3 text-white-40 line-through">${tokenPrice > 0 ? parseFloat(tokenPrice.toFixed(6)) : ""}</span><span>${!!discountedTokenPrice ? parseFloat(discountedTokenPrice.toFixed(6)) : ""}</span></> : ""}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="row promo">
                        <div className="col-12 col-md-7">
                          <div className="position-relative apply-btn-parent">
                            <input onChange={(el) => getCode(el)}  id="code" type="text" className="form-control mb-10-sm" placeholder="Insert Code"/>
                            <button className="apply-btn" onClick={() => onClickApplyCode()}>Apply Code</button>
                          </div>
                        </div>
                        <div className="col-12 col-md-5">
                          <button onClick={() => buyTokens()} className="btn btn-buy" disabled={!(totalAmount > 0)}>Approve and Buy Tokens</button>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-12">
                      <p className="text-white mt-3 d-none-desk text-white-40 font-14 mt-5">Tokens will be delivered upon payment to your connected purchase address and will be tradable when the IEO closes.</p>
                    </div>
                  </div>
                </div>
                <p className="text-white mt-3 d-none-sm">Tokens will be delivered upon payment to your connected purchase address and will be tradable when the IEO closes.</p>
                <br className="d-none-sm" />
                <br className="d-none-sm" />
                <br className="d-none-sm" />
                <br className="d-none-sm" />
              </div>
            </div>
          </div>
        </div>
      </div>




      <section className="copy-copoun">
        <div className="container-wrapper">
          <div className="text-white">
            <div className="row align-items-center">
              <div className="col-md-8">
                <div className="d-flex align-items-center d-unset-sm">
                  <div className="text-uppercase mr-3">MY COUPON CODE</div>
                  {!!userCoupon ?
                  <div className="font-65 text-truncate font-55-sm"><b>{userCoupon}</b></div>
                  :
                  <div><b><i>Please make a purchase to get your code or Connect Wallet.</i></b></div>
                  }
                </div>
              </div>
              <div className="col-md-4">
                <div className="copy-btn-parent text-right">
                  <button className="btn btn-copy" onClick={() => copy(userCoupon)} disabled={!userCoupon}>Copy</button>
                  {/* <button className="btn btn-share ml-3">Share</button>*/}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <footer>
        <div className="container-wrapper ">
          <div className="row">
            <div className="col-md-6">
              <img alt="" className='footer-logo' src={logo} width={'250px'} />
              <br />
              <br />
              <br />
              <p className="text-white-40">SuperOne Limited <br />
                Portland House <br />
                Glacis Road<br />
                Gibraltar, GX11 1AA
              </p>
            </div>

            <div className="col-md-6 d-none-sm">
             
            </div>
          </div>
        </div>
        <div className="copyright mt-5">
          <div className="container-wrapper mt-4">
            <div className="footer-links">
              <div>
                <a className="text-white-40" href="https://super.one/privacy-policy" target="blank">Privacy policy</a>
              </div>
              <div className="s_parent-footer">
                <ul className="footer-social">
                  <li>
                    <a href="https://twitter.com/superonelive" target="blank">
                      <img alt="" src={twitter} width={''} className="" />
                    </a>
                  </li>
                  <li>
                    <a href="https://www.facebook.com/superonenews" target="blank">
                      <img alt="" src={facebook} width={''} className="" />
                    </a>
                  </li>
                  <li>
                    <a href="https://medium.com/@superonenews" target="blank">
                      <img alt="" src={medium} width={''} className="" />
                    </a>
                  </li>
                  <li>
                    <a href="https://t.me/superonenews" target="blank">
                      <img alt="" src={telegram} width={''} className="" />
                    </a>
                  </li>
                </ul>
                <p className="text-white-40 ml-4 ml-0-sm-imp">&copy; {year} All right reserved. </p>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {!!loading ?
      <div className="loader">
        <div className="main-loader" role="status">

        </div>
      </div>

      : ""}


      {couponModal ?
        <section className="nft-modal dark-modal">
          <div className="modal-dialog">
            <div className="modal-content">
              <button onClick={() => cancelModel()} type="button" className="close text-right" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="modal-body">
                <div className="row align-items-center">
                  <div className="col-md-7">
                    <div className="font-12 text-uppercase text-white">COUPON CODE</div>
                    <div className="font-56 font-55-sm text-white text-truncate">{userCoupon}</div>
                  </div>
                  <div className="col-md-5 text-right text-center-sm-imp ">
                    <div className="mt-30-sm">
                      <button className="btn btn-copy" onClick={() => copy(userCoupon)} disabled={!userCoupon}>Copy</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section> : ""}

        {show ? (
        <GeneralModal title={title} message={message} setShow={setShow} setLink={setLink} link={link} />
        ) : null}

    </>


  );
}

const mapStateToProps = (state) => {
  return {
    account: state.account,
    web3: state.web3,
  };
};

export default connect(mapStateToProps, {})(Header);

